import { render, staticRenderFns } from "./PapermanActionPicker.vue?vue&type=template&id=60fc5783&"
import script from "./PapermanActionPicker.vue?vue&type=script&lang=js&"
export * from "./PapermanActionPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports